import "./bootstrap";
import "../css/all.css";
import "./app.scss";
import.meta.glob(["../images/**"]);
import * as Sentry from "@sentry/react";

import { createRoot } from "react-dom/client";
import { createInertiaApp, router } from "@inertiajs/react";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { configureBrandingStrings } from "./resources/localization";
import type { PageProps } from './types';

const appName =
  window.document.getElementsByTagName("title")[0]?.innerText || "Laravel";

createInertiaApp<PageProps>({
  title: (title) => `${title} - ${appName}`,
  resolve: (name) =>
    resolvePageComponent(
      `./Pages/${name}/index.tsx`,
      import.meta.glob("./Pages/**/*.tsx"),
    ),
  setup({ el, App, props }) {
    const { branding } = props.initialPage.props;

    configureBrandingStrings(branding);
    const root = createRoot(el);

    router.on("success", (event) => {
      const { primary, secondary } = (
        event.detail.page.props.branding as PageProps["branding"]
      ).colors;

      document.documentElement.style.setProperty("--primary-color", primary);
      document.documentElement.style.setProperty("--secondary-color", secondary);

      if (typeof window.Beacon === "function") {
        window.Beacon("config", { color: primary });
      }
    });

    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
      environment: import.meta.env.APP_ENV,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      // Performance Monitoring
      tracesSampleRate: import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE, // 0-1.0  Capture 100% of the transactions
      // Session Replay
      replaysSessionSampleRate: import.meta.env.VITE_SENTRY_REPLAY_SAMPLE_RATE,
      replaysOnErrorSampleRate: import.meta.env
        .VITE_SENTRY_ERROR_REPLAY_SAMPLE_RATE, // 0-1.0
    });

    root.render(<App {...props} />);
  },
  progress: {
    color: "#4B5563",
  },
});
